import React, { useRef } from 'react';
import { AlertCircleIcon, FileTextIcon, UploadIcon, XIcon } from 'lucide-react';
interface FileUploadFieldProps {
  id: string;
  label: string;
  file: File | null;
  onChange: (file: File | null) => void;
  error?: string;
  hint: string;
}
export function FileUploadField({
  id,
  label,
  file,
  onChange,
  error,
  hint
}: FileUploadFieldProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const clear = () => {
    onChange(null);
    if (inputRef.current) inputRef.current.value = '';
  };
  return <div data-id="element-125" data-mp="34kby6pgnqwf4">
      <p className="block text-sm font-medium text-plum" data-id="element-126" data-mp="34k2c3cyqh9ep">
        {label} <span className="font-normal text-plum/50" data-id="element-127" data-mp="39kgjqtwfahc7">(optional)</span>
      </p>
      <p id={`${id}-hint`} className="mt-1 text-xs text-plum/60" data-id="element-128" data-mp="3ejjbjcne6r28">
        {hint}
      </p>
      {file ? <div className="mt-2 flex items-center gap-3 rounded-lg border border-plum/15 bg-white px-4 py-3" data-id="element-129" data-mp="1f78hwia155h2">
          <FileTextIcon className="h-5 w-5 shrink-0 text-copper-deep" aria-hidden="true" data-id="element-130" data-mp="1k50bdgqboznd" />
          <span className="min-w-0 flex-1 truncate text-sm text-plum" data-id="element-131" data-mp="1ucr5lntmk4ys">{file.name}</span>
          <span className="text-xs text-plum/55" data-id="element-132" data-mp="1plskmaxoyip7">{(file.size / 1024 / 1024).toFixed(1)} MB</span>
          <button type="button" onClick={clear} className="rounded-full p-1 text-plum/60 transition-colors duration-150 hover:bg-limestone hover:text-plum" aria-label={`Remove ${file.name}`} data-id="element-133" data-mp="1km6863pot6hg">
            <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-134" data-mp="2dalapqrmtwbw" />
          </button>
        </div> : <label htmlFor={id} className={`mt-2 flex cursor-pointer items-center justify-center gap-3 rounded-lg border border-dashed bg-white px-4 py-6 text-sm text-plum/70 transition-colors duration-150 hover:border-copper hover:text-plum focus-within:border-copper ${error ? 'border-danger' : 'border-plum/25'}`} data-id="element-135" data-mp="28cjurepi6d4n">
          <UploadIcon className="h-5 w-5 text-copper-deep" aria-hidden="true" data-id="element-136" data-mp="nvx6wdx3xmph" />
          <span data-id="element-137" data-mp="pdlwupo3h7co">
            <span className="font-medium text-copper-deep" data-id="element-138" data-mp="pd2kdoh7rb61">Choose a file</span> to upload
          </span>
          <input ref={inputRef} id={id} type="file" accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" aria-describedby={`${id}-hint${error ? ` ${id}-error` : ''}`} aria-invalid={error ? true : undefined} className="sr-only" onChange={e => onChange(e.target.files?.[0] ?? null)} data-id="element-139" data-mp="ubdywcige9ul" />
        </label>}
      {error && <p id={`${id}-error`} className="mt-2 flex items-start gap-1.5 text-sm text-danger" data-id="element-140" data-mp="3svdq07dyvxcg">
          <AlertCircleIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-141" data-mp="1ojefflmzah4" />
          {error}
        </p>}
    </div>;
}